import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-analytics-monthly-reviews",
  templateUrl: "./analytics-monthly-reviews.component.html",
  styleUrls: ["./analytics-monthly-reviews.component.scss"],
})
export class AnalyticsMonthlyReviewsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
